import { render, staticRenderFns } from "./RemoveProposalVariants.vue?vue&type=template&id=68dfd006"
import script from "./RemoveProposalVariants.vue?vue&type=script&lang=js"
export * from "./RemoveProposalVariants.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports